import AppSubMenu from "./AppSubMenu";
import { useTranslation } from "react-i18next";

const AppMenu = () => {
    const { t } = useTranslation();
    const model = [
        {
            label: t("dashboard.dashboard"),
            icon: "pi pi-home",
            items: [
                {
                    label: t("map.map"),
                    icon: "pi pi-fw pi-map",
                    to: "/"
                }
            ]
        }
    ];

    return <AppSubMenu model={model} />;
};

export default AppMenu;
